import heydoctor from 'app/vendor/heydoctor';
import { EducationModel as Education } from '@goodrx/heydoctor-sdk';
import { Stores, Store } from 'app/lib/synaptik';

interface State {
  drugInformation?: string;
  fetchingDrugInformation?: boolean;
  education?: Education;
  fetchingEducation?: boolean;
}

export class EducationStore extends Store<State, Stores> {
  state: State = {};

  fetchDrugInformation = async (params: { ndc?: string; rxcui?: string }) =>
    this.runAsync({
      key: 'fetchingDrugInformation',
      work: async () => {
        const drugInformation = await heydoctor.education.fetchDrugInformation(params);

        this.setState({
          drugInformation,
        });
      },
    });

  fetchEducation = async (id: number) =>
    this.runAsync({
      key: 'fetchingEducation',
      work: async () => {
        const education = await heydoctor.education.fetchEducation(id);
        this.setState({
          education,
        });
      },
    });
}
